import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

import {
    ANIMATION_TIMING_FUNCTION,
    AUTOCOMPLETE_TRANSFORM_X,
    AUTOCOMPLETE_WIDTH,
    FAST_ANIMATION_DURATION_MS,
    LIST_ITEM_HEIGHT,
} from "app/modules/project-from-comparison/config";

const { carbon, bluegrey } = colorsPalettes;

export const Container = styled(Stack)`
    background-color: ${bluegrey[100]};
    border-radius: 3px;
    padding: 0 8px 8px 8px;
    gap: 4px;

    max-height: 313px;
    overflow-y: auto;
    overflow-x: hidden;

    .AutocompleteWebsitesCreatingProject {
        width: ${AUTOCOMPLETE_WIDTH}px;
        transform: translateX(${AUTOCOMPLETE_TRANSFORM_X}px);
    }
`;

export const HeaderContainer = styled(Flex)`
    position: sticky;
    top: 0;
    left: 0;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-top: 16px;
    margin-bottom: 4px;
    background-color: ${bluegrey[100]};
`;

export const Header = styled.p`
    ${setFontVariant("input2Bold")};
    color: ${carbon[500]}CC;
    margin: 0;
`;

export const Count = styled.p`
    ${setFontVariant("body2", carbon[300])};
    margin: 0;
`;

export const List = styled.ul<{ $items: number }>`
    margin: 0;
    padding: 0;
    list-style: none;
    height: ${({ $items }) => $items * LIST_ITEM_HEIGHT}px;
    transition: height ${FAST_ANIMATION_DURATION_MS}ms ${ANIMATION_TIMING_FUNCTION};

    display: flex;
    flex-direction: column;
    gap: 0;
`;

export const StyledIconButton = styled(IconButton)`
    display: flex;
    flex-shrink: 0;
`;
